module.exports = __webpack_public_path__ + "static/media/arrow.dc911f4e.svg";